import React, { useEffect, useRef, useState } from "react";

const RiskSiteMap = ({ focusSite, refCodeId }) => {
  const iframeRef = useRef();
  const getURLOgsMap = process.env.REACT_APP_OGS_MAP_URL;
  const urlIframe = `${getURLOgsMap}/${refCodeId && refCodeId}`;
  const assetCode = focusSite?.basic_info?.asset_code;
  const [iframeIsLoading, setIframeIsLoading] = useState(true);

  useEffect(() => {
    if (assetCode && iframeRef?.current) {
      iframeRef?.current?.contentWindow.postMessage(
        {
          type: "CHANGE_URL",
          asset_code: assetCode,
        },
        getURLOgsMap
      );
    }
  }, [assetCode, iframeRef?.current]);

  return (
    <div className="w-full h-full relative">
      <iframe
        ref={iframeRef}
        src={urlIframe}
        className="w-full grow rounded-lg"
        height="100%"
        title="DAP System"
        allow="geolocation"
        onLoad={() => setIframeIsLoading(false)}
      />
    </div>
  );
};

export default RiskSiteMap;
